module.exports = __webpack_public_path__ + "static/media/filled_bar_M1_tall.b1943775.svg";